<template>
  <section>
    <el-dialog
        :close-on-click-modal="false"
        title="修改主驾基本工资"
        :lock-scroll="true"
        :visible.sync="dialogFormVisible"
        width="500px"
    >
      <section v-loading="getDetailLoading">
        <qx-custom-form @sub="sub" :noSubBtn="true" ref="customForm" :formData="formData" labelWidth="150px">
        </qx-custom-form>
      </section>
      <section slot="footer" class="dialog-footer">
        <div>
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button
              type="primary"
              @click="customFormPost"
              :loading="subLoading || getDetailLoading"
          >确 定</el-button
          >
        </div>

      </section>
    </el-dialog>
  </section>

</template>

<script>
import {dealNumber} from '@qx/utils';
import {updateDriverBasealaryDouble} from 'api/operate';

export default {
  data () {
    return {
      freightOfOrder: '',
      getDetailLoading: false, // 获取详情loading
      dialogFormVisible: false,
      subLoading: false, // 提交loading
      type: '', // add/新增 edit/修改
      merLoading: false, // 商户选项loading中
      originData: {},
      formData: {
        form: [
          {
            label: '主驾基本工资',
            value: 'driverBasealary',
            type: 'input',
            onInput: (driverBasealary) => {
              this.$refs.customForm.setVal('driverBasealary', dealNumber(driverBasealary, false));
            },
            onBlur: () => this.setFreightOfOrder(),
          },
        ],
        rules: {
          driverBasealary: [ // 主驾基本工资
            { required: true, message: '请输入主驾基本工资', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {

    /**
     * @param {Object} item 修改的项
     * @returns {void}
     * @description 打开弹窗并初始化数据
     */
    show (item) {
      this.dialogFormVisible = true; // 打开弹窗
      this.$nextTick(() => {
        this.$refs.customForm && this.$refs.customForm.reset();
        this.originData = item;
        this.freightOfOrder = this.getNumberText(this.originData.freightOfOrderStr, this.originData.freightOfOrderDouble, '0');
        item.driverBasealary = item.driverBasealaryDouble;
        this.$refs.customForm.setVal('driverBasealary', item.driverBasealaryDouble);
        this.$refs.customForm.setVal(item);
      });
      this.getDetailLoading = false;
    },
    getNumberText (...values) {
      const value = values.find((item) => item !== null && item !== undefined && item !== '' && Number.isFinite(Number(item)));
      return value === undefined ? '' : String(value);
    },
    setFreightOfOrder () {// “主驾基本工资”联动"本趟运费""实发比例"
      const driverBasealary = Number(this.$refs.customForm.getVal('driverBasealary'));
      const actualProportion = Number(this.getNumberText(this.originData.actualProportionStr, this.originData.actualProportion, '100'));
      if (!Number.isFinite(driverBasealary)) {
        this.freightOfOrder = '0';
      } else if (!Number.isFinite(actualProportion) || actualProportion === 0) {
        this.freightOfOrder = driverBasealary.toFixed(2);
      } else {
        this.freightOfOrder = (driverBasealary / actualProportion * 100).toFixed(2);
      }
    },
    customFormPost () {
      this.$refs.customForm.sub();
    },

    /**
     * @param {Object} form 表单数据
     * @returns {void}
     * @description 弹窗确定按钮事件
     */
    async sub (form) {
      this.subLoading = true;
      let updateType = '';
      if ((this.originData.orderState >= 7)) {
        updateType = '1';
      } else if (this.originData.orderState >= 1 && this.originData.orderState <= 4) {
        updateType = '1';
      } else if (this.originData.orderState < 7 && this.originData.updateType >= 3) {
        updateType = '5';
      } else {
        updateType = '0';
      }
      const res = await updateDriverBasealaryDouble({
        orderId: this.originData.orderId,
        updateType: updateType,

        driverBasealaryDouble: form.driverBasealary,
        freightOfOrder: this.getNumberText(this.freightOfOrder, this.originData.freightOfOrderStr, this.originData.freightOfOrderDouble, form.driverBasealary, '0'),
        actualProportion: this.getNumberText(this.originData.actualProportionStr, this.originData.actualProportion, '100'),
      });
      this.subLoading = false;
      if (!res.failed) {
        this.dialogFormVisible = false; // 关闭弹窗
        this.$message({
          type: 'success',
          message: '保存成功',
        });
        this.$emit('sub');
      }

    },
  },
};
</script>

<style lang="scss" scoped>
</style>
